import { defaultFill } from './utils/constants';
var muiChartLineBase = {
    paths: [
        {
            path: 'M15.8846415,5.5 C15.7847381,5.3 15.5849313,5.1 15.2852211,5.1 C14.9855108,5 14.785704,5.1 14.4859938,5.2 L8.9913065,9 L7.39285201,6.4 C7.29294861,6.2 7.09314179,6 6.79343158,6 C6.49372136,5.9 6.29391455,6 6.09410774,6.1 L0.799227244,9.3 C0.499517028,9.4 0.399613622,9.6 0.299710217,9.9 C0.199806811,10.2 0.299710217,10.4 0.399613622,10.7 C0.499517028,10.9 0.799227244,11.1 0.999034056,11.2 C1.29874427,11.3 1.49855108,11.2 1.7982613,11.1 L6.19401114,8.4 L7.79246563,11 C7.89236904,11.2 8.19207926,11.4 8.39188607,11.4 C8.49178947,11.4 8.49178947,11.4 8.59169288,11.4 C8.79149969,11.4 8.9913065,11.3 9.09120991,11.2 L15.4850279,6.7 C15.6848347,6.6 15.8846415,6.4 15.8846415,6.1 C16.0844483,6 15.9845449,5.8 15.8846415,5.5 Z',
            fill: defaultFill,
        },
        {
            path: 'M15.0854142,14.2 L1.7982613,14.2 L1.7982613,0.9 C1.7982613,0.4 1.39864768,8.8817842e-16 0.89913065,8.8817842e-16 C0.399613622,8.8817842e-16 -8.87320489e-16,0.4 -8.87320489e-16,0.9 L-8.87320489e-16,15.1 C-8.87320489e-16,15.6 0.399613622,16 0.89913065,16 L15.0854142,16 C15.5849313,16 15.9845449,15.6 15.9845449,15.1 C15.9845449,14.6 15.5849313,14.2 15.0854142,14.2 Z',
            fill: defaultFill,
        },
    ],
    title: 'chart line',
    width: 24,
    height: 24,
    rotate: 0,
    translate: [4, 4],
};
var muiChartLine = {
    base: muiChartLineBase,
};
export { muiChartLine };
//# sourceMappingURL=chartLine.js.map